// extracted by mini-css-extract-plugin
module.exports = {"Message":"ChatMessage_Message__qd-y_","Right":"ChatMessage_Right__1IrVR","Left":"ChatMessage_Left__3Gm0q","Text":"ChatMessage_Text__10jTi","Photo":"ChatMessage_Photo__HK-nm"};